//vendors
import React from 'react';

//components
import {InfoIcon} from './info_icon';
import { Tooltip } from '../tooltip';

//styles
import styles from './tooltip_info.module.scss';

type Props = {
  text: string,
  placement: "top" | "bottom" | "right" | "left" | "top-start" | "top-end" | "bottom-start" | "bottom-end" | "right-start" | "right-end" | "left-start" | "left-end",
  dark: boolean
};

export const TooltipInfo = (props: Props) => {
  return (
    <Tooltip message={props.text} placement={props.placement} dark={props.dark}>
      <span className={styles.iconWrap}>
        <InfoIcon />
      </span>
    </Tooltip>
  )
}

TooltipInfo.defaultProps = {
  placement: "bottom-end",
  dark: true
}
